import { FuseAnimate, FusePageSimple } from "@fuse";
import _ from "@lodash";
import { Fab, Hidden, IconButton, withStyles } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdAdd, MdMenu } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaOrcamentoDialog from "./EmpresaPessoaOrcamentoDialog";
import EmpresaPessoaOrcamentoList from "./EmpresaPessoaOrcamentoList";
import * as Actions from "./Store/Actions/EmpresaPessoaOrcamentoActions";
import EmpresaPessoaOrcamentoReducer from "./Store/Reducers/EmpresaPessoaOrcamentoReducer";

const styles = theme => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        color: theme.palette.text.primary,
    }
});

const TIPO = 112;
class EmpresaPessoaOrcamentoApp extends XAPPComponent {

    state = {
        filters: null,
    };

    componentDidMount() {
        const { xappRouteParams, idparent, foreingKey } = this.props;
        this.props.list("SELECIONAR", xappRouteParams, idparent, TIPO, foreingKey);
        this.props.getTemplate(TIPO);
    }

    componentDidUpdate(prevProps) {
        if (!_.isEqual(prevProps.EmpresaPessoaOrcamento.novopedido, this.props.EmpresaPessoaOrcamento.novopedido)) {
            this.props.changeTabPedido();
        }
    }

    gerarPedido = (_AValue) => {
        var obj = {
            idtarefaprocesso: this.props.foreingKey,
            idpessoaformulario: this.props.idparent,
            idorcamento: _AValue.idpessoaformulario
        };
        this.props.gerarPedido(obj, this.props.xappRouteParams);
    };

    render() {
        const { foreingKey, openNewDialog, xappRouteParams, idparent, datapessoa } = this.props;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    <FusePageSimple
                        classes={{
                            contentCardWrapper: "pb-80"
                        }}
                        content={
                            <React.Fragment>
                                <Hidden lgUp>
                                    <IconButton
                                        onClick={() => this.pageLayout.toggleLeftSidebar()}
                                        aria-label="open left sidebar"
                                    >
                                        <MdMenu className="text-white" />
                                    </IconButton>
                                </Hidden>
                                <div className="flex w-full justify-end items-end">
                                    <FuseAnimate animation="transition.expandIn" delay={300}>
                                        <Fab
                                            id={"fab-add-orcamento"}
                                            color="primary"
                                            aria-label="add"
                                            className=""
                                            onClick={() => openNewDialog()}
                                        >
                                            <MdAdd className="text-24 text-white" />
                                        </Fab>
                                    </FuseAnimate>
                                </div>
                                <EmpresaPessoaOrcamentoList
                                    xappRouteParams={xappRouteParams}
                                    idparent={idparent}
                                    changeSelected={this.changeSelected}
                                    tipo={TIPO}
                                    gerarPedido={this.gerarPedido}
                                />
                            </React.Fragment>
                        }
                        sidebarInner
                        onRef={instance => {
                            this.pageLayout = instance;
                        }}
                        innerScroll
                    />
                    {/*  <EmpresaPessoaOrcamentoDialogAtendimento
                             xappRouteParams={xappRouteParams}
                             idparent={this.props.idparent}
                         /> */}
                    <EmpresaPessoaOrcamentoDialog
                        xappRouteParams={xappRouteParams}
                        idparent={this.props.idparent}
                        tipo={TIPO}
                        datapessoa={datapessoa}
                        foreingKey={foreingKey}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        gerarPedido: Actions.gerarPedido,
        list: Actions.list,
        openNewDialog: Actions.openNewDialog,
        getTemplate: Actions.getTemplate
    }, dispatch);
}

function mapStateToProps({ EmpresaPessoaOrcamento }) {
    return {
        EmpresaPessoaOrcamento: EmpresaPessoaOrcamento,
    };
}

export default withReducer("EmpresaPessoaOrcamento", EmpresaPessoaOrcamentoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaPessoaOrcamentoApp))));
